// MyAccount.tsx — stub screen for the "Account" nav item.
//
// Lives at route "account". Shows user's basic info + a placeholder layout.
// Wire up real profile fields / preferences as needed. The unified nav
// handles sign-out and language switching, so this screen doesn't repeat them.

import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../AuthProvider";
import { UserCircle } from "@phosphor-icons/react";

const FONT_STACK =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

export default function MyAccount() {
  const { t, i18n } = useTranslation();
  const { user, isAdmin } = useAuth();

  const rows = [
    { key: "fullName", value: user?.user_metadata?.full_name || "—" },
    { key: "email",    value: user?.email || "—" },
    { key: "role",     value: isAdmin ? t("myAccount.adminRole", { defaultValue: "Admin" })
                                       : t("myAccount.memberRole", { defaultValue: "Member" }) },
    { key: "language", value: i18n.language === "ko" ? "한국어" : "English" },
  ];

  return (
    <div
      style={{
        minHeight: "calc(100vh - 96px)",
        background: "#0a0618",
        color: "#f8fafc",
        fontFamily: FONT_STACK,
        padding: "32px 24px 80px",
      }}
    >
      <main style={{ maxWidth: 720, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 32 }}>
          <div
            style={{
              width: 64, height: 64, borderRadius: 18,
              background: "linear-gradient(135deg, #818cf8, #a78bfa)",
              color: "#0a0618",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >
            <UserCircle size={40} weight="duotone" />
          </div>
          <div>
            <h1 style={{ margin: 0, fontSize: 32, fontWeight: 800, letterSpacing: "-0.5px" }}>
              {t("myAccount.title", { defaultValue: "My Account" })}
            </h1>
            <p style={{ margin: "4px 0 0", color: "#94a3b8", fontSize: 14 }}>{user?.email}</p>
          </div>
        </div>

        <div
          style={{
            background: "rgba(15, 11, 42, 0.85)",
            border: "1px solid rgba(139,92,246,0.22)",
            borderRadius: 20, padding: 8,
            backdropFilter: "blur(20px)",
          }}
        >
          {rows.map((row, i) => (
            <div
              key={row.key}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 20px",
                borderTop: i ? "1px solid rgba(139,92,246,0.12)" : "none",
              }}
            >
              <div style={{ color: "#94a3b8", fontSize: 13 }}>
                {t(`myAccount.fields.${row.key}`, { defaultValue: row.key })}
              </div>
              <div style={{ color: "#fff", fontSize: 14, fontWeight: 500 }}>{row.value}</div>
            </div>
          ))}
        </div>

        {/* Placeholder for future profile editing / preferences / activity log */}
        <p style={{ color: "rgba(148,163,184,0.6)", fontSize: 12, marginTop: 24, textAlign: "center" }}>
          {t("myAccount.moreSoon", { defaultValue: "Profile editing and preferences coming soon." })}
        </p>
      </main>
    </div>
  );
}
